import { Component,OnInit,OnDestroy,AfterViewInit,Input } from "@angular/core";
import { NgbModal,NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { takeWhile } from "rxjs/operators";

import {
    DtgListType
} from "src/app/shared/vo";

@Component({
  templateUrl: "./dtg.manage.team.search.component.html"
  ,styleUrls: ["./dtg.manage.team.search.component.scss"]
})
export class DtgManageTeamSearchComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    listItem:any[];
    DtgListType = DtgListType;

    constructor(
        private modalService: NgbModal
        ,public activeModal: NgbActiveModal
    ) {
        
    }

    ngOnInit() {
        
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {}

    clickCancel(){
        this.activeModal.close({
            "result":"cancel"
        });
    }

    callbackSelectTeam(teamInfo:any){
        this.clickSelectTeam(teamInfo);
    }

    clickSelectTeam(teamInfo:any){
        this.activeModal.close({
            "result":"ok"
            ,"teamInfo":teamInfo
        });
    }
}
